import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductTourComponent } from '../product-tour.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideAngularModule } from 'lucide-angular';

@NgModule({
	declarations: [ProductTourComponent],
	imports: [CommonModule, MatTooltipModule, LucideAngularModule],
	exports: [ProductTourComponent],
	providers: [],
})
export class ProductTourModule {}
